module.exports = __webpack_public_path__ + "img/chessnut.ac71cca2.png";